import type { MappingProfile } from 'shared/products/mapping/domain/mappingProfile';

export interface MappingProfileFormValues {
  name: string;
  description: string;
  priority: number;
  sourceCode: string;
  minWidth: number | null;
  maxWidth: number | null;
  minHeight: number | null;
  maxHeight: number | null;
  minLength: number | null;
  maxLength: number | null;
  minMoisture: number | null;
  maxMoisture: number | null;
  targetProductId: string | null;
  targetPackageTypeId: string | null;
  targetPackagingId: string | null;
}

// Maps a source profile to the dialog's form values; copyName lets the copy path suffix the name.
export function buildMappingProfileFormValues(
  source: MappingProfile,
  copyName: (name: string) => string,
): MappingProfileFormValues {
  return {
    name: copyName(source.name),
    description: source.description,
    priority: source.priority,
    sourceCode: source.sourceCode ?? '',
    minWidth: source.minWidth,
    maxWidth: source.maxWidth,
    minHeight: source.minHeight,
    maxHeight: source.maxHeight,
    minLength: source.minLength,
    maxLength: source.maxLength,
    minMoisture: source.minMoisture,
    maxMoisture: source.maxMoisture,
    targetProductId: source.targetProductId,
    targetPackageTypeId: source.targetPackageTypeId,
    targetPackagingId: source.targetPackagingId,
  };
}
